import styles from "./TVR.module.css";
import SelfEmployedTVR from "./BorrowerType/Self Employed/SelfEmployedTVR";
import {useParams } from "react-router-dom";

const TVR = () => {
  const { loanid } = useParams();
  const loanID = loanid;

  return (
    <>
      <div className={styles.mainContainer}>
        <p style={{ fontSize: "12px", marginTop: "1vh", marginBottom: "-1vh" }}>
          <span style={{ color: "red" }}>Note:</span> Fields with (*) are mandatory
        </p>
        <hr className={styles.hr} />
        <div className={styles.mainContant}>
          <SelfEmployedTVR loanID={loanID} />
        </div>
      </div>
    </>
  );
};

export default TVR;
